import { Grid } from '@change/ds-layout/next';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';
import { PageMembershipAwareness } from '../components/PageMembershipAwareness';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<Grid className="px-0">
			<PageBanner />
			<div className="col-span-full mx-4 mt-3 flex flex-col gap-8">
				<PageMeta />
				<PageHeading />
				<PageBody />
			</div>
			<div className="col-span-full m-4 md:my-12 xl:mx-0">
				<PageMembershipAwareness />
			</div>
			<PageFooter />
		</Grid>
	);
};
